// Zerodesk 

export const environment = {
  production: false,
    adminUrl: 'https://qaadmin.oneills.photography',
    apiUrl: 'https://qaadmin.oneills.photography/api',
    apiBaseUrl: 'https://qaadmin.oneills.photography',
    webBaseUrl: 'https://qaadmin.oneills.photography',
    paymentUrl: 'https://testsecure.peachpayments.com/checkout',
    photoUrl: 'https://oneills-images.s3.af-south-1.amazonaws.com'
};


// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/environments/environment.ts